
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Ω / Icons / platforms / iOS","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 23.334 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.558 28c-1.441 0-3.32-1.6-4.9-4.172A19.072 19.072 0 01.759 19.7 14.937 14.937 0 010 15.171a8.473 8.473 0 012.351-6.225 7.141 7.141 0 014.88-2.109H7.3a7.793 7.793 0 012.816.722 5.31 5.31 0 001.732.5 5.423 5.423 0 001.679-.493 9.047 9.047 0 013.239-.815 4.439 4.439 0 01.445.022 7.067 7.067 0 012.285.5 6.175 6.175 0 012.835 2.274 6.462 6.462 0 00-2.306 2.534 5.9 5.9 0 00-.6 3.044 6.2 6.2 0 001.11 3.106 7.018 7.018 0 002.8 2.314 18.021 18.021 0 01-2.529 4.689c-.937 1.231-2.385 2.7-3.962 2.732h-.086a4.815 4.815 0 01-2.081-.524 5.594 5.594 0 00-2.456-.589 5.935 5.935 0 00-2.573.607 5.3 5.3 0 01-2.015.54zM11.93 6.466c-.1 0-.2 0-.3-.012a5.707 5.707 0 011.441-4.264A5.87 5.87 0 0117.242 0a6.11 6.11 0 01-1.6 4.63 5.11 5.11 0 01-3.706 1.835z","fill":"#011936"}})])
          )
        }
      }
    